var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0169 6.41671L16.7057 9.79439L19.2501 11.4906V14.6667H18.1769C17.7994 13.5986 16.7808 12.8334 15.5834 12.8334C14.386 12.8334 13.3674 13.5986 12.9899 14.6667H9.01027C8.63275 13.5986 7.61412 12.8334 6.41675 12.8334C5.21938 12.8334 4.20074 13.5986 3.82323 14.6667H2.75008V6.41671H15.0169ZM19.2501 16.5H18.1769C17.7994 17.5681 16.7808 18.3334 15.5834 18.3334C14.386 18.3334 13.3674 17.5681 12.9899 16.5H9.01027C8.63275 17.5681 7.61411 18.3334 6.41675 18.3334C5.21938 18.3334 4.20075 17.5681 3.82323 16.5H2.75008C1.73756 16.5 0.916748 15.6792 0.916748 14.6667V6.41671C0.916748 5.40419 1.73756 4.58337 2.75008 4.58337H15.0169C15.7113 4.58337 16.3461 4.97571 16.6567 5.59682L18.1278 8.53903L21.0834 10.5095V14.6667C21.0834 15.6792 20.2626 16.5 19.2501 16.5ZM7.33342 15.5834C7.33342 16.0896 6.92301 16.5 6.41675 16.5C5.91049 16.5 5.50008 16.0896 5.50008 15.5834C5.50008 15.0771 5.91049 14.6667 6.41675 14.6667C6.92301 14.6667 7.33342 15.0771 7.33342 15.5834ZM16.5001 15.5834C16.5001 16.0896 16.0897 16.5 15.5834 16.5C15.0772 16.5 14.6667 16.0896 14.6667 15.5834C14.6667 15.0771 15.0772 14.6667 15.5834 14.6667C16.0897 14.6667 16.5001 15.0771 16.5001 15.5834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.87c1bb162b541629a7dc3eb2c42ee0f9.svg";
export { ForwardRef as ReactComponent };